import { createFileRoute } from "@tanstack/react-router";
import { DashboardHeader } from "@/components/DashboardHeader";
import { ClinicalPageShell, ClinicalSection } from "@/components/clinical";
import { WebhookGovernancePanel } from "@/components/admin/WebhookGovernancePanel";

export const Route = createFileRoute("/app/webhooks")({
  component: WebhooksPage,
  head: () => ({ meta: [{ title: "Diagnóstico de pagos" }] }),
});

function WebhooksPage() {
  return (
    <div>
      <DashboardHeader
        title="Diagnóstico de pagos"
        subtitle="Si un cobro no aparece o se duplicó, acá ves las notificaciones que llegaron de los medios de pago."
      />
      <ClinicalPageShell>
        <ClinicalSection
          title="Historial de notificaciones"
          description="Uso de diagnóstico. La configuración diaria de cómo te pagan está en Configuración → Pagos."
        >
          <WebhookGovernancePanel />
        </ClinicalSection>
      </ClinicalPageShell>
    </div>
  );
}
